import React from "react";

import { Navigate } from "react-router";
import { useContentDetailsPage } from "@companion-core/shared/app/Components/DetailsPages/ContentDetailsPage/hooks/contentDetailsPage";
import { ContentTemplate } from "@companion-core/shared/app/Components/DetailsPages/Templates/Content/ContentTemplate";
import { CommonDetailsPageProps } from "@companion-core/shared/app/Components/DetailsPages/DetailsPage.model";

import "@companion-core/web/src/Assets/Styles/scss/contentDetailsPage.scss";

export const ContentDetailsPage = ({ id, origin, contentType }: CommonDetailsPageProps) => {
  const { data, isFetching } = useContentDetailsPage({
    id,
    pageSlug: origin,
    contentType,
  });

  if (!isFetching && data) {
    return <ContentTemplate contentType={contentType} data={data} />;
  } else if (!isFetching && !data) {
    return <Navigate to="/not-found" />;
  }
};
